import React, { useState, useEffect, useRef } from "react";
import SideBar from "../Dashboard/StudentDashboard/Sidebar/SideBar";
import ProfileBar from "../Dashboard/StudentDashboard/Profilebar/ProfileBar";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    CircularProgress,
    CardContent,
    Card,
    Divider,
    Grid,
    Button,
    Grid2,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Paper,
    Stack,
    TextField,
    Typography,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Snackbar,
    Link as MuiLink,
    Container,
} from "@mui/material";
import Breadcrumb from "../StudentBreadcrumb/Breadcrumb";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import guidelinesImg from "./guidelines.jpg";
import { API_LoginURL } from "../../config";
import { Img_APIURL } from "../../config";
import { Link } from "react-router-dom";
import axios from "axios";
import MuiAlert from "@mui/material/Alert";

const StudentProjects = () => {
    const guidelines = [
        "The Kidpreneur model is built to turn young ideas into real business opportunities.",
        "Students submit innovative ideas, receive expert support to build functional projects,",
        "and then see those projects transformed into market-ready products.",
        "Successful innovations generate royalties for the students, introducing them early to entrepreneurship,",
        "ownership, and real commercial impact."
    ];
    const [dense, setDense] = useState(false);
    const [mediaFiles, setMediaFiles] = useState([]);
    const [documentFile, setDocumentFile] = useState({});
    const [documentFileName, setDocumentFileName] = useState(""); //State to store document file name
    const [projectName, setProjectName] = useState("");
    const [projectDescription, setProjectDescription] = useState("");
    // modifications from sudeep 18/3/2025
    const [assignments, setAssignments] = useState([]); // Store fetched projects
    const [totalProjects, setTotalProjects] = useState(0); // New state for total projects count
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [approvalSnackbarOpen, setApprovalSnackbarOpen] = useState(false);
    const [submittedProjects, setSubmittedProjects] = useState([]); // Store the fetched submitted projects
    const prevTotalProjects = useRef(0);
    const [error, setError] = useState("");
    const [showAllProjects, setShowAllProjects] = useState(false); // State to toggle between filtered and all projects

    useEffect(() => {
        console.log("MEDIAFILES ======= ", mediaFiles);
        console.log("PROJECTNAME ======= ", projectName);
        console.log("PROJECTDESCRIPTION ======= ", projectDescription);
        console.log("DOCUMENTFILE ======= ", documentFile);
    }, [mediaFiles, projectName, projectDescription, documentFile]);

    // Fetch submitted projects
    const fetchSubmittedProjects = async () => {
        try {
            const response = await axios.get(
                `${API_LoginURL}project/ProjectSubmissionListById`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem("token"),
                    },
                }
            );
            console.log(response.data);
            setSubmittedProjects(response.data); // Update the submitted projects state
        } catch (error) {
            console.error("Error fetching submitted projects:", error);
        }
    };

    // Fetch assignments from API
    const fetchAssignments = async () => {
        try {
            const response = await axios.get(
                `${API_LoginURL}project/ProjectMasterList`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem("token"),
                    },
                }
            );
            setAssignments(response.data); // Set fetched project data
        } catch (error) {
            console.error("Error fetching assignments:", error);
        } finally {
            setLoading(false);
        }
    };
    // Fetch total project count
    // const fetchTotalProjects = async () => {
    //   try {
    //     const response = await axios.get('http://4.188.88.117:5000/project/ProjectApprovedCount', {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: localStorage.getItem("token"),
    //       }
    //     });
    //     console.log(response.data);
    //     setTotalProjects(response.data);  // Assuming the response contains { count: <number> }
    //     // Trigger approval notification if totalProjects has increased
    //     if (response.data > totalProjects) {
    //       setApprovalSnackbarOpen(true);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching project count:", error);
    //   }
    // };
    const fetchTotalProjects = async () => {
        try {
            const response = await axios.get(
                `${API_LoginURL}project/ProjectApprovedCount`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem("token"),
                    },
                }
            );
            console.log(response.data);

            if (response.data > prevTotalProjects.current) {
                setApprovalSnackbarOpen(true); // Show approval Snackbar
            }
            prevTotalProjects.current = response.data; // Update previous value
            setTotalProjects(response.data);
        } catch (error) {
            console.error("Error fetching project count:", error);
        }
    };

    // Fetch assignments on component mount
    useEffect(() => {
        fetchAssignments();
        fetchTotalProjects(); // Fetch the total project count on component mount
        fetchSubmittedProjects(); // Fetch submitted projects on component mount
        const interval = setInterval(() => {
            fetchTotalProjects(); // Every X seconds check for update
        }, 5000); // Poll every 5 seconds (adjust if needed)

        return () => clearInterval(interval); // Clean up on unmount
    }, []);

    // Filter and slice projects by status (Approved, Pending, Rejected)
    const filterAndSliceProjects = (projects) => {
        const approved = projects
            .filter((p) => p.status === "Approved")
            .slice(0, 1);
        const pending = projects
            .filter((p) => p.status === "Pending")
            .slice(0, 1);
        const rejected = projects
            .filter((p) => p.status === "Rejected")
            .slice(0, 1);
        return [...approved, ...pending, ...rejected];
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "Approved":
                return "green";
            case "Rejected":
                return "red";
            case "Pending":
                return "blue";
            default:
                return "gray";
        }
    };

    const handleMediaUpload = (e) => {
        const files = Array.from(e.target.files);
        setMediaFiles([...mediaFiles, ...files]);
    };

    const removeMediaFile = (index) => {
        const newFiles = [...mediaFiles];
        newFiles.splice(index, 1);
        setMediaFiles(newFiles);
    };

    const handleDocumentUpload = (e) => {
        const file = e.target.files[0]; // Get the uploaded file
        setDocumentFile(file);
        setDocumentFileName(file.name); // Store the document file name
    };

    // const handleSubmit = (e) => {
    //   e.preventDefault();
    //   console.log({
    //     projectName,
    //     projectDescription,
    //     mediaFiles,
    //     documentFile
    //   });
    //   alert('Form submitted!');
    // };

    // modifications by sudeep 18/3/2025

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setError("");
        const formData = new FormData();
        formData.append("ProjectName", projectName);
        formData.append("ProjectSummary", projectDescription);
        formData.append("ProjectDocument", documentFile);

        mediaFiles.forEach((file) => {
            formData.append("MediaFiles", file);
        });

        // console.log("FORMDATA >>>>>>>>>>", formData);
        for (let pair of formData.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }

        if (
            projectName !== "" &&
            projectDescription !== "" &&
            documentFile.length !== 0 &&
            mediaFiles.length !== 0
        ) {
            try {
                const response = await axios.post(
                    `${API_LoginURL}project/ProjectSubmission`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: localStorage.getItem("token"),
                        },
                    }
                );

                if (response.status === 200) {
                    setSuccess(true);
                    setSnackbarOpen(true); // Show success message
                    resetForm();
                    fetchSubmittedProjects();
                } else {
                    // alert("Submission failed.");
                    setError("Submission failed."); // Show error message
                    setSnackbarOpen(true);
                }
            } catch (error) {
                console.error("Error submitting project:", error);

                // Check if the error response has data and capture the specific message
                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.response
                ) {
                    setError(error.response.data.response); // Set the error message from the API response
                } else {
                    setError("An unexpected error occurred."); // Show a fallback error message
                }

                setSnackbarOpen(true); // Show error message in Snackbar
            } finally {
                setLoading(false);
            }
        } else {
            setError("Input can't be Empty!!!"); // Show error message
            setSnackbarOpen(true);
            setLoading(false);
        }
    };

    const resetForm = () => {
        setProjectName("");
        setProjectDescription("");
        setMediaFiles([]);
        setDocumentFile({});
        setDocumentFileName("");
    };

    // Close Snackbar
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const handleCloseApprovalSnackbar = () => {
        setApprovalSnackbarOpen(false);
    };

    return (
        <>
            <SideBar />
            <Box
                sx={{
                    flexGrow: 1,
                    position: "relative",
                    width: "calc(100vw - 60px)",
                    padding: "20px",
                    height: "100vh",
                    overflowY: "scroll",
                    left: "60px",
                }}
            >
                <Breadcrumb />
                <Stack spacing={2}>
                    {/* Project Guidelines & Total Projects */}
                    <Box bgcolor="white" borderRadius="12px" sx={{ p: 2 }}>
                        <Grid2 container spacing={2} alignItems="center">
                            {/* Guidelines */}
                            <Grid2 item xs={12} md={8}>
                                <Accordion
                                    defaultExpanded
                                    sx={{
                                        background: "transparent",
                                        boxShadow: "none",
                                    }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel-content"
                                        id="panel-header"
                                    >
                                        <Typography variant="h5">
                                            Project Guidelines
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                        >
                                            <Box>
                                                <img
                                                    src={guidelinesImg}
                                                    alt="Guidelines"
                                                    style={{
                                                        height: "500px",
                                                        width: "auto",
                                                    }}
                                                />
                                            </Box>
                                            <List dense={dense} sx={{ ml: 2 }}>
                                                {guidelines.map(
                                                    (guideline, index) => (
                                                        <ListItem
                                                            key={index}
                                                            disablePadding
                                                        >
                                                            <ListItemText
                                                                primaryTypographyProps={{
                                                                    fontWeight: 500,
                                                                }}
                                                                primary={
                                                                    guideline
                                                                }
                                                            />
                                                        </ListItem>
                                                    )
                                                )}
                                            </List>
                                        </Stack>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid2>

                            {/* Total Projects */}
                            <Grid2 item xs={12} md={4}>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        p: 2,
                                        borderRadius: "12px",
                                        height: "100%",
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <Typography variant="subtitle1" mb={1}>
                                        Total Projects
                                    </Typography>
                                    <Box
                                        sx={{
                                            width: 100,
                                            height: 100,
                                            borderRadius: "50%",
                                            border: "5px solid #e0e0e0",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {console.log(
                                            "Total Projects:",
                                            totalProjects
                                        )}
                                        <Typography variant="h5">
                                            {totalProjects !== undefined
                                                ? totalProjects
                                                : "Loading..."}
                                        </Typography>
                                    </Box>
                                </Paper>
                            </Grid2>
                        </Grid2>
                    </Box>

                    {/* Project Submission Form */}
                    <Stack
                        spacing={2}
                        component="form"
                        onSubmit={handleSubmit}
                        sx={{
                            p: 2,
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                        }}
                    >
                        <Typography variant="h5" mb={3}>
                            Submit Project
                        </Typography>

                        {/* Media Upload */}
                        <Typography fontWeight="medium" mb={1}>
                            Media Upload (Image & Video)
                        </Typography>
                        <Paper
                            variant="outlined"
                            sx={{
                                border: "2px dashed #ccc",
                                p: 3,
                                textAlign: "center",
                                mb: 2,
                            }}
                        >
                            <input
                                type="file"
                                multiple
                                accept="image/*,video/*"
                                id="media-upload"
                                style={{ display: "none" }}
                                onChange={handleMediaUpload}
                            />
                            <label htmlFor="media-upload">
                                <Button
                                    variant="outlined"
                                    component="span"
                                    startIcon={<UploadFileIcon />}
                                >
                                    Upload Additional file
                                </Button>
                            </label>
                            <Typography
                                variant="caption"
                                display="block"
                                mt={1}
                            >
                                Attach file. File size of your documents should
                                not exceed 10MB
                            </Typography>
                        </Paper>

                        {/* Media Previews */}
                        <Grid2 container spacing={2} mb={3}>
                            {mediaFiles.map((file, index) => (
                                <Grid2 item key={index}>
                                    <Paper
                                        sx={{
                                            width: 80,
                                            height: 80,
                                            backgroundColor: "#f0f0f0",
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 1,
                                        }}
                                    >
                                        <IconButton
                                            size="small"
                                            sx={{
                                                position: "absolute",
                                                top: 0,
                                                right: 0,
                                            }}
                                            onClick={() =>
                                                removeMediaFile(index)
                                            }
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                        <Typography
                                            variant="caption"
                                            align="center"
                                        >
                                            {file.name.slice(0, 6)}...
                                        </Typography>
                                    </Paper>
                                </Grid2>
                            ))}
                        </Grid2>

                        {/* Project Name Test */}
                        <FormControl fullWidth sx={{ mb: 3 }}>
                            <TextField
                                labelId="project-name-label"
                                id="project-name"
                                value={projectName}
                                label="Project Name"
                                onChange={(e) => setProjectName(e.target.value)}
                            />
                        </FormControl>

                        {/* Project Description */}
                        <TextField
                            fullWidth
                            label="Project Description"
                            variant="outlined"
                            multiline
                            rows={4}
                            value={projectDescription}
                            onChange={(e) =>
                                setProjectDescription(e.target.value)
                            }
                            sx={{ mb: 3 }}
                        />

                        <Typography fontWeight="medium" mb={1}>
                            Project Document - (Word or PDF)
                        </Typography>
                        <Paper
                            variant="outlined"
                            sx={{
                                border: "2px dashed #ccc",
                                p: 3,
                                textAlign: "center",
                                mb: 3,
                            }}
                        >
                            <input
                                type="file"
                                accept=".pdf,.doc,.docx"
                                id="document-upload"
                                style={{ display: "none" }}
                                onChange={handleDocumentUpload}
                            />
                            <label htmlFor="document-upload">
                                <Button
                                    variant="outlined"
                                    component="span"
                                    startIcon={<UploadFileIcon />}
                                >
                                    Upload Additional file
                                </Button>
                            </label>
                            <Typography
                                variant="caption"
                                display="block"
                                mt={1}
                            >
                                Attach file. File size of your documents should
                                not exceed 10MB
                            </Typography>
                        </Paper>

                        {/* Buttons */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 2,
                            }}
                        >
                            <Button variant="outlined">Cancel</Button>
                            <Button
                                variant="contained"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? (
                                    <CircularProgress
                                        size={24}
                                        color="inherit"
                                    />
                                ) : (
                                    "Submit"
                                )}
                            </Button>
                        </Box>

                        {/* Submitted Projects Section */}
                        <Stack>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 2,
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{ fontWeight: 600 }}
                                >
                                    Submitted Projects
                                </Typography>
                                {/* "See All" link */}
                                {/* {Object.keys(submittedProjects).length !==
                                    0 && (
                                    <MuiLink
                                        component="button"
                                        sx={{
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                        }}
                                        onClick={() =>
                                            setShowAllProjects(!showAllProjects)
                                        }
                                    >
                                        {showAllProjects
                                            ? "See Less"
                                            : "See All"}
                                    </MuiLink>
                                )} */}
                            </Box>

                            {/* Show a loader until the projects are fetched */}
                            {/* {loading ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        minHeight: 200,
                                    }}
                                >
                                    <CircularProgress />
                                </Box>
                            ) : ( */}
                            <Container
                                disableGutters
                                maxWidth={false}
                                sx={{
                                    width: "100%",
                                    display: "grid",
                                    gridTemplateColumns: "repeat(5,1fr)",
                                    gap: 2,
                                }}
                            >
                                {Object.keys(submittedProjects).length === 0 ? (
                                    <Typography
                                        variant="subtitle1"
                                        color="secondary"
                                    >
                                        No Submitted Projects Available
                                    </Typography>
                                ) : (
                                    submittedProjects.map(
                                        (
                                            project //filterAndSliceProjects
                                        ) => (
                                            <Box
                                                key={
                                                    project.projectSubmissionId
                                                }
                                                sx={{
                                                    height: "auto",
                                                }}
                                            >
                                                <Link
                                                    to={`/project/${project.projectSubmissionId}`}
                                                    style={{
                                                        textDecoration: "none",
                                                    }}
                                                >
                                                    <Card
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection:
                                                                "column",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                width: "100%",
                                                                height: 120,
                                                                overflow:
                                                                    "hidden",
                                                                borderRadius:
                                                                    "8px",
                                                            }}
                                                        >
                                                            {/* <video
                                                                src={
                                                                    project
                                                                        .mediaFiles[0]
                                                                        ?.projectMediaPath
                                                                        ? Img_APIURL +
                                                                          `${project.mediaFiles[0].projectMediaPath}`
                                                                        : "https://via.placeholder.com/100"
                                                                }
                                                                alt="Thumbnail"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit:
                                                                        "cover",
                                                                }}
                                                                controls
                                                                autoPlay
                                                            /> */}
                                                            {project.mediaFiles[0]?.projectMediaPath?.endsWith(
                                                                ".mp4"
                                                            ) ? (
                                                                <video
                                                                    src={
                                                                        Img_APIURL +
                                                                        project
                                                                            .mediaFiles[0]
                                                                            .projectMediaPath
                                                                    }
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit:
                                                                            "cover",
                                                                    }}
                                                                    controls
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={
                                                                        project
                                                                            .mediaFiles[0]
                                                                            ?.projectMediaPath
                                                                            ? Img_APIURL +
                                                                              project
                                                                                  .mediaFiles[0]
                                                                                  .projectMediaPath
                                                                            : "/placeholder_image.png"
                                                                    }
                                                                    alt="Thumbnail"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit:
                                                                            "cover",
                                                                    }}
                                                                />
                                                            )}
                                                        </Box>
                                                        <CardContent
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection:
                                                                    "column",
                                                                mt: 2,
                                                            }}
                                                        >
                                                            <Typography variant="h6">
                                                                {project.projectName ===
                                                                    null ||
                                                                project.projectName ===
                                                                    ""
                                                                    ? "Untitled Project"
                                                                    : project.projectName}
                                                            </Typography>
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                            >
                                                                {
                                                                    project.projectSubmissionDate
                                                                }
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    mt: 2,
                                                                    color: getStatusColor(
                                                                        project.status
                                                                    ),
                                                                }}
                                                            >
                                                                {project.status}
                                                            </Typography>
                                                        </CardContent>
                                                    </Card>
                                                </Link>
                                            </Box>
                                        )
                                    )
                                )}
                            </Container>
                            {/* )} */}
                        </Stack>

                        {/* Success Snackbar */}
                        <Snackbar
                            open={snackbarOpen}
                            autoHideDuration={6000}
                            onClose={handleCloseSnackbar}
                        >
                            <MuiAlert
                                onClose={handleCloseSnackbar}
                                severity={error ? "error" : "success"}
                                sx={{ width: "100%" }}
                            >
                                {error || "Project submitted successfully!"}
                            </MuiAlert>
                        </Snackbar>
                    </Stack>
                    {/* Approval Snackbar */}
                    {/* <Snackbar
            open={approvalSnackbarOpen}
            autoHideDuration={6000}
            onClose={handleCloseApprovalSnackbar}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <MuiAlert onClose={handleCloseApprovalSnackbar} severity="success" sx={{ width: '100%' }}>
              Your project has been approved!
            </MuiAlert>
          </Snackbar> */}
                </Stack>
            </Box>
        </>
    );
};

export default StudentProjects;
